import { StandardEvents } from '@shopify/events';

/**
 * Formatea centavos CLP a un string de moneda chilena, p.ej. 1234500 -> "$12.345".
 * @param {number} cents
 */
function formatCLP(cents) {
  const value = Math.round(cents / 100);
  return '$' + value.toLocaleString('es-CL');
}

/**
 * @param {HTMLElement} root
 * @param {number} cartTotalCents
 */
function render(root, cartTotalCents) {
  const umbralPesos = parseInt(root.dataset.umbral, 10) || 30000;
  const umbralCents = umbralPesos * 100;
  const mensaje = root.querySelector('[data-mt-envio-mensaje]');
  const progreso = root.querySelector('[data-mt-envio-progreso]');
  if (!mensaje || !progreso) return;

  const pct = Math.min(100, Math.round((cartTotalCents / umbralCents) * 100));
  progreso.style.width = pct + '%';

  if (cartTotalCents >= umbralCents) {
    mensaje.textContent = '¡Tu pedido ya califica para envío gratis!';
  } else {
    const faltante = umbralCents - cartTotalCents;
    mensaje.textContent = `Te faltan ${formatCLP(faltante)} para tu envío gratis`;
  }
}

function actualizar() {
  const root = document.querySelector('[data-mt-envio-gratis]');
  if (!root) return;
  fetch('/cart.js', { headers: { Accept: 'application/json' } })
    .then((res) => res.json())
    .then((cart) => render(root, cart.total_price))
    .catch(() => {});
}

if (document.querySelector('[data-mt-envio-gratis]')) {
  actualizar();
  document.addEventListener(StandardEvents.cartLinesUpdate, (event) => {
    event.promise?.then(actualizar).catch(() => {});
  });
}
